import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectChangeLogHistory = (state: RootState) => state.changeLogHistory;

export const selectChangeLogHistoryData = createSelector(
  [selectChangeLogHistory],
  ({ data, filters, total, dataRequestId }) => ({
    data,
    filters,
    total,
    loading: !!dataRequestId,
  }),
);

export const selectChangeLogHistoryFilters = createSelector([selectChangeLogHistory], ({ filters }) => filters);

export const selectChangeLogHistoryCampaignOptions = createSelector(
  [selectChangeLogHistory],
  ({ campaignOptions, campaignOptionsRequestId }) => ({
    options: campaignOptions,
    loading: !!campaignOptionsRequestId,
  }),
);
